import React from 'react';
import styled from 'styled-components';
import { AlertTriangleIcon } from '../Layout/icons';

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.01em;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors?.warning?.dark || '#92400E'};
  background: ${({ theme }) => theme.colors?.warning?.light || '#FFFBEB'};
  border: 1px solid ${({ theme }) => theme.colors?.warning?.main || '#D97706'}33;

  svg {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
  }
`;

/**
 * Indicador informativo de atraso na entrega.
 * Só renderiza quando `delayed === true` (valor vindo da API).
 *
 * @param {{ delayed?: boolean, className?: string }} props
 */
export default function DeliveryDelayedBadge({ delayed = false, className }) {
    if (!delayed) return null;

    return (
        <Badge
            className={className}
            role="status"
            title="A data atual é posterior à data agendada e a entrega ainda não foi finalizada"
        >
            <AlertTriangleIcon />
            <span>Atrasada</span>
        </Badge>
    );
}
